//
// src/view/topNav.view.js
//

const TOP_NAV_TEMPLATE = `
	<ul class="pull-left">
		<li><a href="#<%= app.getLanguage() %>" class="hvr-sink"><i class="fa fa-home"></i></a></li>
		<li><a href="index.html#<%= app.getLanguage() %>/books" class="hvr-sink"><%= app.localeManager.get("menu.books") %></a></li>
	</ul>
	<div class="logo-container">
		<img src="./assets/images/reads_logo_<%= app.getLanguage() %>.png">
	</div>
	<ul class="pull-right">
		<li><i id="openFilters" class="fa fa-filter subnav closed hvr-sink" aria-hidden="true"></i></li>
		<li><a><i id="openSearch" class="fa fa-search" aria-hidden="true"></i></a></li>
		<li class="locale-buttons">
			<a data-locale="en" style="cursor: pointer">EN</a>
			|
			<a data-locale="fr" style="cursor: pointer">FR</a>
		</li>
	</ul>
	<!-- FILTER MENU FORM -->
	<ul id="filterMenuForm" >
		<li>
		<span id="closeFilters" class="menu-element">
			<i class="fa fa-times filterMenu" aria-hidden="true" style="display: inline-block"></i>
			<%= app.localeManager.get("buttons.cancel") %>
		</span>
		</li>
		<li>
		<span id="clearFilters" class="menu-element">
			<i class="fa fa-refresh filterMenu" aria-hidden="true" style="display: inline-block"></i>
			<%= app.localeManager.get("buttons.reset") %>
		</span>
		</li>
		<li>
		<span id="saveFilters" class="menu-element">
			<i class="fa fa-check filterMenu" aria-hidden="true" style="display: inline-block"></i>
			<%= app.localeManager.get("buttons.submit") %>
		</span>
		</li>
	</ul>
	<!-- SEARCH MENU FORM -->
	<ul id="searchMenuForm">
		<li>
			<span id="closeSearch" class="menu-element">
				<i class="fa fa-times filterMenu" aria-hidden="true" style="display: inline-block"></i>
				<%= app.localeManager.get("buttons.cancel") %>
			</span>
		</li>
		<li>
			<span id="submitSearch" class="menu-element">
				<i class="fa fa-check filterMenu" aria-hidden="true" style="display: inline-block"></i>
				<%= app.localeManager.get("buttons.submit") %>
			</span>
		</li>
	</ul>
`;

const TopNavView = Backbone.View.extend({

	events: {
		"click #closeFilters"		: "closeFilters",
		"click #openFilters"	 	: "openFilters",
		"click #saveFilters"	 	: "submitFilterSelection",
		"click #openSearch"		 	: "openSearch",
		"click #closeSearch"	 	: "closeSearch",
		"click #submitSearch"	 	: "submitSearch",
		"click #clearFilters"	 	: "resetFilters",
		"click li.locale-buttons a"	: "switchLocale",
	},

	tagName: "nav",

	className: "main-nav text-center",

	id: "top-nav",

	render: function() {
		this.$el.html(this.template());

		return this;
	},

	template: _.template(TOP_NAV_TEMPLATE),

	// Animate the filter menu form elements IN
	animateComponentOptionsIn: function(selector) {
		new TimelineMax().staggerTo(selector, 0.5, { y: -53, ease: Power2.easeOut }, 0.1);
	},

	// Animate the filter menu form elements OUT
	animateComponentOptionsOut: function() {
		new TimelineMax().staggerTo(this.$el.find("ul.pull-right li"), 0.5, { y: 0, ease: Power2.easeOut }, 0.1);
	},

	resetFilters: function() {
		// Reset the filters to an empty state
		app.components.filters.resetFilters();
		// Close the filter menu
		this.closeFilters();
	},

	// Close the filter view 
	closeFilters: function() {
		app.resume();
		app.components.filters.close();
		new TimelineMax().staggerTo("#filterMenuForm li", 0.5, { y: 80, ease: Power2.easeOut, onComplete: () => (this.animateComponentOptionsOut()) }, 0.1);
	},

	// Close the search view
	closeSearch: function() {
		app.components.searchBar.close();
		new TimelineMax().staggerTo("#searchMenuForm li", 0.5, { y: 80, ease: Power2.easeOut, onComplete: () => (this.animateComponentOptionsOut()) }, 0.1);
	},

	// Open the filter view
	openFilters: function() {
		app.components.filters.open();
		// override the default freeze behavior which will set pointer-events to "none" on the navbar
		app.components.nav.$el.css("pointer-events", "all");
		$("#filterMenuForm").show();
		new TimelineMax().staggerTo(this.$el.find("ul.pull-right li"), 0.5, { y: 80, ease: Power2.easeOut, onComplete: () => {
			this.animateComponentOptionsIn("#filterMenuForm li");
		}}, 0.1);
	},

	openSearch: function() {
		app.resume();
		new TimelineMax().staggerTo(this.$el.find("ul.pull-right li"), 0.5, { y: 80, ease: Power2.easeOut, onComplete: () => {
			this.animateComponentOptionsIn("#searchMenuForm li")
		}}, 0.1);
		app.components.searchBar.open();
	},

	submitFilterSelection: function() {
		app.components.filters.submitFilters();
		this.closeFilters();
	},

	submitSearch: function() {
		app.components.searchBar.submitSearch();
		this.closeSearch();
	},

	switchLocale: function(e) {
		// replace the current language hash by the selected one
		let newRoute = window.location.hash.replace(/#[\w]{2}(\/)?/gi, "#" + $(e.target).attr("data-locale") + "/");

		app.router.navigate(newRoute, { trigger: true, replace: false });
	}
});